import { CircularProgress, Grid } from '@mui/material';
import Image from 'next/image';
import ConfigContext from 'src/context/config';
import useNonNullContext from 'src/hooks/useNonNullContext';

const Loading: React.FC = () => {
  const tenantConfig = useNonNullContext(ConfigContext);

  return (
    <Grid
      container
      sx={{
        justifyContent: 'center',
        pt: 5,
        pb: 5,
      }}
    >
      {tenantConfig.loadingImgUrl ? (
        <Image
          src={tenantConfig.loadingImgUrl}
          alt="loading"
          width="264"
          height="160"
        />
      ) : (
        <CircularProgress />
      )}
    </Grid>
  );
};

export default Loading;
